function waitForElementToDisplay(selector, callback, checkFrequencyInMs, timeoutInMs) {
  var startTimeInMs = Date.now();
  (function loopSearch() {
    if (document.querySelector(selector) != null) {
      callback();
      return;
    }
    else {
      setTimeout(function () {
        if (timeoutInMs && Date.now() - startTimeInMs > timeoutInMs)
          return;
        loopSearch();
      }, checkFrequencyInMs);
    }
  })();
};

/**
 * Voice search extension is used to support voice search.
*/
T4SThemeSP.VoiceSearchExtension = function() {
  let recognition = null;

  const setReady = () => {
      console.log('VoiceSearchExtension: ready called.');
      if(recognition && navigator && navigator.permissions) {
        navigator.permissions.query({ name: "microphone" })
          .then((result) => {
            console.log('VoiceSearchExtension: navigator result', result);
            if(result.state != 'denied') {
              $('[data-action-voicesearch]').attr('data-action-voicesearch', 'ready');
            }
          });
      }
  };
  
  const init = () => {
    let Recognition = (window.SpeechRecognition || window.webkitSpeechRecognition || window.mozSpeechRecognition || window.msSpeechRecognition);
    
    console.log('VoiceSearchExtension: Speach Recongition init called.', Recognition);
 
    if (Recognition != null) {
      recognition = new Recognition();
      recognition.continuous = false;
      recognition.interimResults = false;
      recognition.lang = "en-GB";

      console.log('VoiceSearchExtension: Speach Recongition available.');

      setReady();

      $(document).on("click", '[data-action-voicesearch="ready"]', (event) => {
        event.preventDefault();
        console.log('VoiceSearchExtension: voice search start');
        try {
          recognition.start();
        } catch (e) {
          console.log(e);
        }
        $('[data-action-voicesearch]').attr('data-action-voicesearch', 'listening');
      });
      
      $(document).on("click", '[data-action-voicesearch="listening"]', (event) => {
        event.preventDefault();
        console.log('VoiceSearchExtension: voice search stopped');
        try {
          recognition.stop();
        } catch (e) {
          console.log(e);
        }
        $('[data-action-voicesearch]').attr('data-action-voicesearch', 'ready');
      });

      recognition.onresult = (e) => {
          $('[data-input-search]').val(e.results[0][0].transcript);
          $('[data-frm-search]').submit();
          $('[data-action-voicesearch]').attr('data-action-voicesearch', 'ready');
      };

      recognition.onspeechend = () => {
        recognition.stop();
      };

      recognition.onerror = (error) => {
          console.log('VoiceSearchExtension: voice error', error);
          // The below errors are not recoverable, and we should disable speech recognition when they occur
          // https://developer.mozilla.org/en-US/docs/Web/API/SpeechRecognitionErrorEvent/error#audio-capture
          if (error.error == 'audio-capture' || error.error == 'not-allowed' || error.error == 'service-not-allowed') {
            $('[data-action-voicesearch]').attr('data-action-voicesearch', 'disabled');
          } else {
            $('[data-action-voicesearch]').attr('data-action-voicesearch', 'ready');
          }
      }
    }
  }

  return {
    init,
    setReady
  };
}();

/**
 * Chat extension is used to support different shopify chat icons.
*/
T4SThemeSP.ChatExtension = function() {
  const CHAT_DATA_COUNT_SELECTOR = '*[data-count-chat]';

  const toggle = () => {
    document.querySelector('inbox-online-store-chat').shadowRoot.querySelector('button.chat-toggle,button.chat-app--close-button').click();
  }
  
  const init = () => {
    var link = document.createElement('link');
    link.type = 'text/css';
    link.rel = 'stylesheet';
    link.href = '//bathandtile.co.uk/cdn/shop/t/120/assets/chat.css?v=116238912860996745851742655525'
    link.onload = () => {
      document.querySelector('inbox-online-store-chat').style.visibility = 'visible';
    }

    document.querySelector('inbox-online-store-chat').shadowRoot.appendChild( link );

    setInterval(function() {
      const unreadMessagesCount = JSON.parse(localStorage.getItem('shopifyChatData'))?.unreadMessagesCount || 0;
      
      if($(CHAT_DATA_COUNT_SELECTOR).text() != unreadMessagesCount) {
        $(CHAT_DATA_COUNT_SELECTOR).text(unreadMessagesCount);
        if(unreadMessagesCount) {
          $(CHAT_DATA_COUNT_SELECTOR).show();
        } else {
          $(CHAT_DATA_COUNT_SELECTOR).hide();
        }
      }
    }, 1000);
  }

  return {
    toggle,
    init
  };
}();

/**
 * HOW THIS WORKS
 * 1) Drawer is created in render_bottom which uses the wishlist section to render its content
 * 2) T4SThemeSP.WishlistExtension.init(); is added to custom JS, which inits the section with current wishlist
 * 3) On wishlist events, the wishlist content is updated
 * TODO: Verify if config can go in window.T4Sconfigs
 * TODO: Update selectors to use new wishlist place holders
 * TODO: Update wishlist section so its specific to this (should we keep old page available just incase?)
**/

T4SThemeSP.WishlistExtension = function() {
  const wishlistSection = 'ecom-wishlist-sidebar-search';
  const wishlistRenderSection = '#shopify-ecom-wishlist-sidebar-search';
  const wishlistDrawerId = '#t4s-wish-drawer';

  let options = {};

  const opend = function() {
    T4SThemeSP.Drawer.opend($(wishlistDrawerId));
  }

  const updateWishListLinks = function() {
    $('.ecom-product__wishlist-link').each((index, element) => {
      $(element).attr('data-action-wishlist', '');
      $(element).attr('data-id', $(element).attr('data-product-id'));
    });
    
    T4SThemeSP.Wishlist.updateAll();
  }

  const init = function (opt) {
    if (!T4SThemeSP.linkWishlist) {
      localStorage.setItem('t4s_wis', '');
    }
    
    $(document).on('update:mini_cart:wishlist', function(e, eventInfo) {
      console.log('[Wishlist Extension] Received mini_cart:wishlist event.');
      
      update();
    });
    
    updateWishListLinks();
    update();
  }

  const update = function() {
    return $.ajax(`${T4SThemeSP.linkWishlist}&sections=${wishlistSection}`).done((response) => {
      const html = $(response[wishlistSection]);
      
      html.find('script').remove();
      html.find('noscript').remove();
      html.find('#ecom-vendors-slider_css').remove();
      
      html.find('.ecom-product__wishlist-link').each((index, element) => {
        $(element).css({
        'background-color': 'white',
          'border-radius': '100%',
          'padding': '5px'
        });
        $(element).href = '#';
        $(element).addClass('is--added');
        $(element).attr('data-action-wishlist', '');
        $(element).attr('data-id', $(element).attr('data-product-id'));
        $(element).find('.ecom-product__wishlist-tooltip').html('Remove from Wishlist');
        $(element).find('svg').html('<use xlink:href="#t4s-icon-wis-remove"></use>');
      });
      
      $(wishlistRenderSection).html(html);
    });
  };

  return {
    opend: opend,
    update: update,
    init: init
  }
}();

/**
 * Helper function which is used to initalize drawer menus (with children) so they
 * expand correctly.
**/
T4SThemeSP.DrawerMenuExtension = function() {
  const isOpenClass = 'is--opend';

  const toggle = (element) => {
      element.hasClass(isOpenClass)
        ? element.removeClass(isOpenClass).children("ul").slideUp(200)
        : element.addClass(isOpenClass).children("ul").slideDown(200);
  };
  
  const init = function() {
    // Only required for shopify preview mode to show drawers when they are selected
    $(document).on("shopify:section:select shopify:block:select", ".t4s-drawer-section-content", function (event) {
      const id = $(event.currentTarget).find(".t4s-drawer").attr('id');
      if (id) {
        T4SThemeSP.Drawer.opend($(`#${id}`));
      }
    });
  
    // Only required for shopify preview mode to hide drawers when they are not selected
    $(document).on("shopify:section:deselect shopify:block:deselect", ".t4s-drawer-section-content", function (event) {
      $(event.currentTarget).find(".t4s-drawer").attr('aria-hidden', 'true');
      $('.t4s-close-overlay').removeClass('is--visible');
    });

    $(document).on("click touch", "[data-drawer-menu-item-toggle]", (event) => {
      event.preventDefault();
      event.stopPropagation();
      const e = $(event.currentTarget).parent();
      toggle($(event.currentTarget).parent());
    });
  };

  return {
    init: init
  }
}();

/**
 * Tile calculator extension function for handling tile calculators
**/
T4SThemeSP.TileCalculatorExtension = function() {

  const recalculateTotal = function(dataTileCalculatorRowsNode) {
    const wastageIncluded = $('[data-tile-calculator-rows] input[name=include_wastage]').is(':checked');
    const total = $(dataTileCalculatorRowsNode).find('[data-tile-calculator-result]')
      .toArray()
      .map((e) => parseFloat($(e).text()) || 0)
      .reduce((a, b) => a + b);

    const quantity = (Math.max(total, 0) * (wastageIncluded ? 1.1 : 1)).toFixed(2);
    $(dataTileCalculatorRowsNode).find('[data-tile-calculator-total-result ]').text(quantity);
    $('#quantity').val(Math.ceil(Math.max(1.0, quantity)));
    $('#quantity')[0].dispatchEvent(new Event('change'));
  }

  const init = function () {
    $(document).on("change", "[data-tile-calculator-rows] input[name=include_wastage]", (event) => {
      const rowsNode = $(event.target).closest('[data-tile-calculator-rows]');
      recalculateTotal($(rowsNode).closest('[data-tile-calculator-rows]'));
    });

    $(document).on("change input", "[data-tile-calculator-row] input", (event) => {
      const rowParentNode = $(event.target).closest('[data-tile-calculator-row]');
      const type = $(rowParentNode).attr('data-tile-calculator-row');
      const multiplier = type == 'include' ? 1 : -1;
  
      const area = $(rowParentNode).find('input')
        .toArray()
        .map((e) => Math.max(parseFloat(e.value), 0))
        .reduce((a,b) => a * b);
  
      $(rowParentNode).find('[data-tile-calculator-result]').text(((area * multiplier) || 0).toFixed(2));
  
      recalculateTotal($(rowParentNode).closest('[data-tile-calculator-rows]'));
    });

    // Prevent enter from causing the tile calculator form to submit
    $(document).on("keydown", "[data-tile-calculator-row] input", (event) => {
      return event.key != "Enter";
    });
    
    $(document).on("click", "[data-tile-calculator-add]", (event) => {
      event.preventDefault();
  
      const type = $(event.target).attr('data-tile-calculator-add');
      const rowsNode = $(event.target).closest('[data-tile-calculator-rows]');
      const templateRow = $(rowsNode).find(`.tile-calculator-row-template[data-tile-calculator-row="${type}"]`);
      const newRow = $(templateRow).clone().insertAfter($('[data-tile-calculator-row]:last'));
  
      $(newRow).removeClass('tile-calculator-row-template').addClass('tile-calculator-row');
      recalculateTotal($(rowsNode).closest('[data-tile-calculator-rows]'));
    });
  
    $(document).on("click", "[data-tile-calculator-remove]", (event) => {
      event.preventDefault();
      const parent = $(event.target).closest('[data-tile-calculator-rows]');
  
      $(event.target).closest('[data-tile-calculator-row]').remove();
      recalculateTotal(parent);
    });

    $(document).on("click", "[data-tile-calculator-toggle]", (event) => {
      const current = $('.tile-calculator').attr('aria-hidden');
      $('.tile-calculator').attr('aria-hidden', current == 'true' ? 'false' : 'true');
    });
  };

  return {
    init
  };
}();

jQuery_T4NT(document).ready(function($) {
  T4SThemeSP.VoiceSearchExtension.init();
  T4SThemeSP.ChatExtension.init();
  T4SThemeSP.WishlistExtension.init();
  T4SThemeSP.DrawerMenuExtension.init();
  T4SThemeSP.TileCalculatorExtension.init();

  // Needs to go in document ready function
  $(document).on("click touch", '#button-trade-login', () => {
     T4SThemeSP.Drawer.opend($('#t4s-login-sidebar'));
  });
});